"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _l10n = require("../../l10n");
var _withLocale = _interopRequireDefault(require("../HOCs/withLocale"));
const Text = _ref => {
  let {
    type,
    intlText,
    text,
    html,
    selected,
    rollover,
    variant,
    className,
    locale
  } = _ref;
  // @ts-ignore
  const Style = _uiKit.Text[type];
  const translate = (0, _l10n.getMessages)(locale);
  return html ? /*#__PURE__*/_react.default.createElement(Style, {
    className: className,
    variant: variant,
    selected: selected,
    dangerouslySetInnerHTML: text ? {
      __html: text
    } : null
  }, intlText && translate(intlText)) : /*#__PURE__*/_react.default.createElement(Style, {
    className: className,
    variant: variant,
    selected: selected,
    rollover: rollover
  }, text || translate(intlText));
};
var _default = exports.default = (0, _withLocale.default)(Text);